module.exports = __webpack_public_path__ + "img/describe2.e75450e6.png";